import { render } from "./consumerWallet.vue?vue&type=template&id=0fedc0a2&scoped=true"
import script from "./consumerWallet.vue?vue&type=script&lang=js"
export * from "./consumerWallet.vue?vue&type=script&lang=js"

import "./consumerWallet.vue?vue&type=style&index=0&id=0fedc0a2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0fedc0a2"

export default script